import { configureWithRelationshipSerializer, configurePaginatedSerializer } from './utils';

const EmailWithRelationshipsSerializer = configureWithRelationshipSerializer({
  includeForeignModelAttrs: {
    event: ['name'],
    modifiedBy: ['name'],
    publishedBy: ['name'],
    createdBy: ['name'],
  },
});

const PaginatedEmailSerializer = configurePaginatedSerializer({ baseSerializer: EmailWithRelationshipsSerializer });

export default {
  email: EmailWithRelationshipsSerializer,
  paginatedEmails: PaginatedEmailSerializer,
};
